// src/components/navigation/BottomNav.js
import React from 'react';
import { AiFillHome, AiOutlineHome } from 'react-icons/ai';
import { IoTrophySharp, IoTrophyOutline } from 'react-icons/io5';
import { RiUserFill, RiUserLine } from 'react-icons/ri';
import { BsBarChartFill, BsBarChart, BsCollectionFill, BsCollection } from 'react-icons/bs';
import './BottomNav.css';

const BottomNav = ({ activeTab, setActiveTab, hasNewAchievement, missingPhoto }) => {
  const tabs = [
    { id: 'home', ActiveIcon: AiFillHome, InactiveIcon: AiOutlineHome, label: 'Home' },
    { id: 'progress', ActiveIcon: BsBarChartFill, InactiveIcon: BsBarChart, label: 'Progress' },
    { id: 'achievements', ActiveIcon: IoTrophySharp, InactiveIcon: IoTrophyOutline, label: 'Achievements' },
    { id: 'library', ActiveIcon: BsCollectionFill, InactiveIcon: BsCollection, label: 'Library' },
    { id: 'profile', ActiveIcon: RiUserFill, InactiveIcon: RiUserLine, label: 'Profile' }
  ];

  const showDot = (id) => {
    if (id === 'achievements' && hasNewAchievement) return true;
    if (id === 'profile' && missingPhoto) return true;
    return false;
  };

  return (
    <nav className="bottom-nav">
      {tabs.map(({ id, ActiveIcon, InactiveIcon, label }) => {
        const isActive = activeTab === id;
        const Icon = isActive ? ActiveIcon : InactiveIcon;
        return (
          <button
            key={id}
            className={`nav-tab ${isActive ? 'active' : ''}`}
            onClick={() => setActiveTab(id)}
          >
            <div className="nav-icon-wrap">
              <Icon size={24} color={isActive ? '#007fff' : '#9ca3af'} />
              {showDot(id) && <span className="nav-dot" />}
            </div>
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;